
import React, { useState } from 'react';

import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    PDFViewer,
    PDFDownloadLink
} from '@react-pdf/renderer';

import {
    styled,
    Card,
    Grid,
    Stack,
    Button,
    Box,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    RadioGroup,
    FormControlLabel,
    Radio,
    Divider
} from '@mui/material';

// import PDFDocumentTemplate from "../../template/pdf/document"

import { getPdfConfigs } from '../../configs/pdfConfigs'

import CommonSectionHeader from "./CommonSectionHeader"

// import { useAppContextFeatures } from 'src/context/AppContext';
import { useSystemPrompt } from '../../hooks/useSystemPrompt'

const renderModes = {
    preview: {
        id: "preview"
    },
    downloadLink: {
        id: "downloadLink"
    }
}

// const documentTypes = PDFDocumentTemplate.documentTypes
const { documentTypes } = getPdfConfigs();

const StyledCard = styled(Box)(({ theme }) => ({
    padding: 0 // theme.spacing(2)
}));

const loadDocumentTemplate = ({ documentType }) => {
    // return PDFDocumentTemplate.documentTypes[documentType]
    return documentTypes[documentType]
}

const checkTemplateHasSelection = ({ documentType }) => {

    const {
        pageSizeOptions,
        pageOrientationOptions,
        renderDataTypes
    } = loadDocumentTemplate({ documentType })

    if (Array.isArray(pageSizeOptions) || Array.isArray(pageOrientationOptions) || Array.isArray(renderDataTypes)) {
        if (pageSizeOptions.length > 1 || pageOrientationOptions.length > 1 || renderDataTypes.length > 1) {
            return {
                pageSizeOptions,
                pageOrientationOptions,
                renderDataTypes
            }
        }
    }

    return false;

}

const initialState = ({ documentType }) => {

    const {
        pageSizeOptions,
        pageOrientationOptions,
        renderDataTypes
    } = loadDocumentTemplate({ documentType })

    let pageSize = 'A4';
    let pageOrientation = 'portrait';
    let renderDataType = "";

    let initialStates = {
        pageSize,
        pageOrientation,
        renderDataType
    }

    if (pageSizeOptions.length === 1) {
        initialStates.pageSize = pageSizeOptions[0]
    }

    if (pageOrientationOptions.length === 1) {
        initialStates.pageOrientation = pageOrientationOptions[0]
    }

    if (renderDataTypes.length === 1) {
        initialStates.renderDataType = renderDataTypes[0]
    }

    return initialStates

}

const CommonPdf = (props) => {

    const routeType = props?.routeType;

    const [pageVariants, setPageVariants] = useState(initialState({ documentType: props?.documentType }))

    const [canProceed, setCanProceed] = useState(false)

    const { promptMessage } = useSystemPrompt()

    const RenderPreview = ({ children }) => {
        return (
            <PDFViewer
                style={{
                    width: '100%',
                    height: '100%',
                    borderWidth: 0
                }}
            >
                {children}
            </PDFViewer>
        )
    }

    const RenderDownloadLink = ({ children, downloadFilename, downloadButtonLabel }) => {
        return (
            <PDFDownloadLink
                document={children}
                fileName={downloadFilename}
            >
                {({ blob, url, loading, error }) =>
                    loading ? 'Loading document...' : downloadButtonLabel
                }
            </PDFDownloadLink>
        )
    }

    const RenderDocumentFromTemplate = ({ documentType, document, data, customData, account }) => {

        return (
            <>
                {/* {
                    PDFDocumentTemplate[documentType]({pageVariants, document, data, customData, account })
                } */}
                {
                    documentTypes[documentType].RenderFunction({ routeType, pageVariants, document, data, customData, account })
                }
            </>
        )
    }

    const handleConfirm = ({ documentType }) => {

        const setting = loadDocumentTemplate({ documentType })

        // check the page size and orientation cannot empty
        if (!pageVariants.pageSize) {
            promptMessage(false, `Please select any of the Page Size`)
            return false;
        }

        // check the page size and orientation cannot empty
        if (!pageVariants.pageOrientation) {
            promptMessage(false, `Please select any of the Page Orientation`)
            return false;
        }

        // check the render data types have options
        if (setting?.renderDataTypes.length > 0) {
            // have to check the option need to select at least one
            if (!pageVariants.renderDataType) {
                promptMessage(false, `Please select any of the Data Types`)
                return false;
            }
        }

        setCanProceed(true)

        return true

    }

    const RenderSelectionSection = ({
        stateId,
        title,
        description,
        options,
        defaultValue
    }) => {

        if (options.length < 1) return <></>

        return (
            <StyledCard
                sx={{
                    p: 2
                }}
            >
                <Grid container spacing={3}>
                    <Grid item md={12} xs={12} sm={12}>
                        <CommonSectionHeader
                            title={title}
                        // subTitle={description}
                        />
                    </Grid>
                    {
                        options.map((value, index) => {

                            // check the current state have selected
                            const selected = pageVariants[stateId];
                            let isSelected = selected === value

                            return (
                                <Grid key={index} item md={3} xs={6} sm={6}>
                                    <Button
                                        fullWidth
                                        key={index}
                                        variant={isSelected ? 'contained' : 'outlined'}
                                        sx={{
                                            display: "block",
                                            px: 3,
                                            py: 1
                                        }}
                                        onClick={() => {
                                            // handleSelect(item?.id)
                                            // handleSelect({ id: stateId, value })
                                            setPageVariants(prev => ({ ...prev, [stateId]: value }))
                                        }}
                                    >
                                        <Typography
                                            // variant="h8"
                                            sx={{
                                                fontSize: '1.0rem',
                                                fontWeight: 800
                                            }}
                                        >
                                            {value}
                                        </Typography>
                                    </Button>

                                </Grid>
                            )
                        })
                    }
                </Grid>
            </StyledCard>
        )
    }

    const RenderSelection = ({ selection, documentType }) => {

        const {
            pageSizeOptions,
            pageOrientationOptions,
            renderDataTypes
        } = selection;

        return (
            <>
                {
                    RenderSelectionSection({
                        stateId: 'pageSize',
                        title: "Page Size",
                        // description: "dsfsdfds",
                        options: pageSizeOptions,
                    })
                }

                {
                    RenderSelectionSection({
                        stateId: 'pageOrientation',
                        title: "Page Orientation",
                        // description: "dsfsdfds",
                        options: pageOrientationOptions,
                    })
                }

                {
                    RenderSelectionSection({
                        stateId: 'renderDataType',
                        title: "Data Types",
                        // description: "dsfsdfds",
                        options: renderDataTypes,
                    })
                }

                {/* {
                    JSON.stringify(pageVariants)
                } */}

                <Divider />

                <Box
                    sx={{
                        px: 2,
                        pt: 2
                    }}
                    onClick={() => handleConfirm({ documentType })}
                >
                    <Button
                        fullWidth
                        variant='outlined'
                    >
                        Preview Pdf
                    </Button>
                </Box>

                {/* {JSON.stringify(pageSizeOptions)}
                {JSON.stringify(pageOrientationOptions)}
                {JSON.stringify(renderDataTypes)} */}
            </>
        )
    }

    const RenderFunction = (
        {
            renderMode,
            documentType,
            document = {
                title: ""
            },
            canvasStyle,
            data,
            customData,
            downloadFilename = "download.pdf",
            downloadButtonLabel = "Download"
        }
    ) => {

        // get the page size options display
        if (canProceed === false) {
            const options = checkTemplateHasSelection({ documentType });

            if (options !== false) {
                return (
                    <RenderSelection
                        documentType={documentType}
                        selection={options}
                    />
                )
            }
        }

        return (
            <Box
                sx={{
                    height: '100%',
                    ...canvasStyle
                }}
            >
                {
                    (renderMode === renderModes.preview.id) &&
                    <RenderPreview>
                        <RenderDocumentFromTemplate
                            documentType={documentType}
                            document={document}
                            data={data}
                            customData={customData}
                        />
                    </RenderPreview>
                }
                {
                    (renderMode === renderModes.downloadLink.id) &&
                    <RenderDownloadLink
                        downloadFilename={downloadFilename}
                        downloadButtonLabel={downloadButtonLabel}
                    >
                        <RenderDocumentFromTemplate
                            documentType={documentType}
                            document={document}
                            data={data}
                            customData={customData}
                        />
                    </RenderDownloadLink>
                }
            </Box>
        )
    }

    return (<>
        <RenderFunction {...props} />
    </>
    );
}

export {
    CommonPdf,
    renderModes,
    documentTypes
}